import Wrapper from './wrapper';
import {
  ICoreVersionResponse,
  IOrgListResponse,
  IOrgUpdateParams,
  IQueryParam,
  IWrapper,
  IUserResponse,
} from './types';
import { IOrg } from '../types/my-types';

class Org {
  wrapper: IWrapper;
  /**
   * @param {Wrapper} wrapper
   */
  constructor(wrapper: Wrapper) {
    this.wrapper = wrapper;
  }

  retrieve(id: string) {
    return this.wrapper.client.get<IOrg, IOrg>(`organizations/${id}/?advanced=true`);
  }
  update(id: string, data: IOrgUpdateParams) {
    return this.wrapper.client.patch(`organizations/${id}/?advanced=true`, data);
  }

  create(label: string) {
    return this.wrapper.client.post('organizations/?advanced=true', { label });
  }

  list(params: IQueryParam) {
    return this.wrapper.client.get<IOrgListResponse, IOrgListResponse>(`organizations/`, {
      params,
    });
  }

  core() {
    return this.wrapper.client.get<ICoreVersionResponse, ICoreVersionResponse>(
      'core-versions/?advanced=true'
    );
  }

  userInfo() {
    return this.wrapper.client.get<IUserResponse, IUserResponse>('user-info/?advanced=true');
  }
}

export default Org;
